import type { QuoteFile } from 'paintscout'

/**
 * Set by the AI generator on an image slot: the id of the scraped site photo that goes with the
 * slot's text (#24101). It lives only between generation and placement —
 * `replaceSectionImages` resolves it to an imported file and strips it before the presentation is
 * saved. See `quoteFile.scrapedImageRef` in presentation-v2.schema.json.
 */
export const SCRAPED_IMAGE_REF_KEY = 'scrapedImageRef'

/** An image slot as the generator leaves it. */
export type ScrapedImageSlot = Partial<QuoteFile> & { [SCRAPED_IMAGE_REF_KEY]?: unknown }

/** Scraped image id → the library file imported for it. */
export type ScrapedImageRefFiles = ReadonlyMap<string, QuoteFile>

export function scrapedImageRefOf(slot: unknown): string | undefined {
  if (!slot || typeof slot !== 'object') return undefined
  const ref = (slot as ScrapedImageSlot)[SCRAPED_IMAGE_REF_KEY]
  return typeof ref === 'string' && ref ? ref : undefined
}

/** Every ref in a presentation's block fields, in document order, first occurrence only. */
export function collectScrapedImageRefs(value: unknown, refs: string[] = []): string[] {
  if (Array.isArray(value)) {
    value.forEach((item) => collectScrapedImageRefs(item, refs))
    return refs
  }
  if (!value || typeof value !== 'object') return refs
  const ref = scrapedImageRefOf(value)
  if (ref && !refs.includes(ref)) refs.push(ref)
  Object.values(value).forEach((child) => collectScrapedImageRefs(child, refs))
  return refs
}
